<style scoped>

</style>

<template>

  <v-container fluid>

    <v-alert outline color="secondary" icon="warning" value="true" v-if="!sensorVariable">
      No data found for the parameters provided. Try a different date range or a different sensor variable.
    </v-alert>

    <v-card>

      <div style="position: relative;">
        <chart :height="500" v-if="chartData" :chart-data="chartData" :options="options"></chart>
      </div>

    </v-card>

  </v-container>

</template>

<script>
  import Chart from '@/components/Station/Chart';
  import chartUtils from '@/utils/chart';
  import CONFIG from '@/config';

  export default {

    name: 'SensorVariableChart',

    components: {
      Chart,
    },

    data() {
      return {
        chartData: null,
        options: null,
      };
    },

    mounted() {
      // console.log('mounted');
      this.buildChart(this.sensorVariable);
    },

    updated() {
      // console.log('updated');
    },

    watch: {

      sensorVariable(variable) {
        console.log(variable);
        this.buildChart(variable);
      },

    },

    methods: {

      buildChart(variable) {
        if (variable) {
          const chartOptions = CONFIG.sensorVariableChartDefaults().options;
          chartOptions.title.text = this.sensorVariable.label;
          chartOptions.scales.yAxes[0].scaleLabel.labelString = this.sensorVariable.units;
          this.options = chartOptions;

          const labels = chartUtils.buildLabels(variable.range);
          const datasets = chartUtils.buildDatasets(variable);
          this.chartData = {
            labels,
            datasets,
          };
        }
      },

    },

    computed: {

      sensorVariable() {
        return this.$store.state.sensorVariable.current;
      },

    },

  };
</script>



// WEBPACK FOOTER //
// src/components/SensorVariable/Chart.vue